import { Component, Inject } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { Category } from '../../../models/category/category.model';
import { CategoryService } from '../../../services/category/category.service';
import { UtilitiesService } from '../../../services/shared/utilities.service';

@Component({
    selector: 'app-subcategory-list',
    templateUrl: './subcategory-list.component.html',
    styleUrls: ['./subcategory-list.component.css']
})
/** subcategory-list component*/
export class SubcategoryListComponent {
  public subcategoryList: Category[];
  //Filter items from grid
  filteredItems: any[];
  public rowsOnPage: number;
  public arrRowsPerPage: number[];
    /** subcategory-list ctor */
  constructor(private readonly categoryService: CategoryService, private readonly utilitiesService: UtilitiesService) {
    this.GetCategoryList();
    this.GetRowsPerPageList();
  }
  GetCategoryList() {
    this.categoryService.GetSubCategoryList().subscribe(
      data => {
        this.subcategoryList = data;
        this.filteredItems = data;
      }
    )
  }

  deleteCategory(id) {
    var ans = confirm("Are you sure to delete this sub category");
    if (ans) {
      this.categoryService.DeleteCategory(id);
      setTimeout(() => {
        this.GetCategoryList();
      }, 2000);
    }
  }
  // Populate the row per page list
  GetRowsPerPageList() {
    this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
    this.rowsOnPage = this.arrRowsPerPage[0];
  }
  // Search the Grid
  onSearch(searchText: string) {
    if (searchText != "") {
      this.filteredItems = this.utilitiesService.GetSearchedResult(this.subcategoryList, searchText);

    } else {
      this.filteredItems = this.subcategoryList;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/category-components/subcategory/subcategory-list/subcategory-list.component.ts